import React, { useState } from "react";
import { X } from "lucide-react";

export function TagInput({ value = [], onChange, placeholder, testId }) {
  const [text, setText] = useState("");

  const add = (v) => {
    const tag = v.trim();
    if (tag && !value.includes(tag)) onChange([...value, tag]);
    setText("");
  };

  return (
    <div className="rounded-2xl border border-line bg-white px-3 py-2.5 flex flex-wrap gap-2 items-center">
      {value.map((tag) => (
        <span
          key={tag}
          className="inline-flex items-center gap-1 rounded-full bg-amber/15 text-ink px-2.5 py-1 text-sm font-medium"
        >
          {tag}
          <button type="button" onClick={() => onChange(value.filter((x) => x !== tag))}>
            <X className="w-3.5 h-3.5" />
          </button>
        </span>
      ))}
      <input
        data-testid={testId}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            add(text);
          }
        }}
        onBlur={() => text && add(text)}
        placeholder={placeholder}
        className="flex-1 min-w-[100px] bg-transparent outline-none text-sm py-1"
      />
    </div>
  );
}
